import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  progressLineSize: {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto'
  },
  buttonCenter: {
    display: 'flex',
    justifyContent: 'center',
    mb: '28px'
  },
  seeMoreButton: {
    height: '36px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: '16px',
    border: `1px solid ${theme.rawColors.darkGrey700}`,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.h5,
    letterSpacing: theme.letterSpacings.caps,
    color: theme.rawColors.darkGrey700,
    backgroundColor: 'transparent',
    ...reusables.mainTransition('color,border-color,background-color', 'cubic-bezier(0, 0, 0.6, 1)', '.5s'),
    '&:hover': {
      color: theme.rawColors.neutralWhite,
      backgroundColor: theme.rawColors.neutralBlack
    }
  }
};